module.exports = __webpack_public_path__ + "img/dea-formazione-ico-contrasto-dispersione-scolastica.e95a0d27.svg";